export default {
	admin:					JSON.parse(localStorage.getItem('admin')),
	token: 					localStorage.getItem('token')
}